module.exports = __webpack_public_path__ + "static/media/newButton.777c87d3.svg";